export default __webpack_public_path__ + "static/affiliate-program-Software-2@2x-174c50aab00e5d8fcdbcf102b0d62561.jpg";